import React from 'react';
import { connect } from 'react-redux';
import MainMenu from 'components/common/mainmenu';
import Card from "./card"
import { addCard } from 'actions/defaultsettings'
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
import toastr from 'toastr';
class DefaultSettings extends React.Component {
	defaultCard(cards) {
		var res = {}
		Object.keys(cards).map((key) => {
			if (cards[key].isdefault) {
				res = cards[key];
			}
		})
		return res;
	}

	addCard() {
		this.props.dispatch(addCard({
			starthour: 8,
			endhour: 17,
			weekdaymask: "0111110"
		}));
		toastr.success("New user settings card is added successfully !")
	}

	isCompanyAdmin(user) {
		var node = this.props.nodeMap[this.props.me.rootnodeid];
		return (user.role == "ADMIN") && node && (node.type == "customer");
	}

	render() {

		var editable = this.isCompanyAdmin(this.props.me);
		return (
			<div className="default-settings-page overwrite--modal--depth">
				<StickyMenu
					withStickyHeader={false}
				>
					<MainMenu
						overviewIsActive={false}
						comparisonIsActive={false}
						onlyLeftMenu={true}
					/>
					<StatsMenu
						leftItemBold="Default Settings"
						leftItems={
							<React.Fragment>
								{editable &&
									<span className="stats-menu__list-item  cursor--pointer" onClick={this.addCard.bind(this)} >
										<div className="stats-menu-btn display--flex__flex--center" >
											<span style={{ fontSize: 27, marginRight: 8 }} className="font-icon icon-addicon" />
											<span className="stats-menu-btn__label">Add Local Settings Card</span>
										</div>
									</span>
								}
							</React.Fragment>
						}
					/>
				</StickyMenu>
				<div className="page-content page-content_padding-modifier display--flex__flex--center" style={{ flexWrap: "wrap" }} >
					{
						Object.keys(this.props.cards).map((key) => {
							if (key == "default") {
								// Default card (company card) has 2 instances : cards[$id] and card["default"]
								return null;
							}
							var card = this.props.cards[key];
							return (
								<Card
									key={card.id}
									card={card}
									root={this.props.root}
									disabled={card.isdefault == 1}
									editable={editable}
									defaultCard={this.defaultCard(this.props.cards)}
								/>
							);
						})
					}
				</div >
			</div >
		);
	}
}

function mapStateToProps(state) {
	return {
		root: state.overviewReducer.customerOverview,
		cards: state.defaultSettingsReducer.card,
		me: state.myAccountReducer.user,
		nodeMap: state.overviewReducer.nodeMap
	};
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultSettings);


// WEBPACK FOOTER //
// ./src/components/pages/defaultsettings/index.jsx